import { render, staticRenderFns } from "./ProgramSetupManager.vue?vue&type=template&id=1c37ba0c&scoped=true"
import script from "./ProgramSetupManager.vue?vue&type=script&lang=js"
export * from "./ProgramSetupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37ba0c",
  null
  
)

export default component.exports